import { Card, Col, Empty, Row, Tabs, Typography } from "antd";
import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { ItemCol } from "./components/item-col";
import { TableReport } from "./components/table.report";
import { SearchBar } from "./components/search";
import useDevice from "./hooks/hook.device";

const { Title } = Typography;

export default function ReportDevice() {
  const { data, device, setDevice, t } = useDevice();
  const { state } = useLocation();
  const [search, setSearch] = useState("");
  const [activeKey, setActiveKey] = useState("");

  useEffect(() => {
    if (data.length > 0) {
      const selected = state?.device ?? data[0];
      setDevice(selected);
      setActiveKey(selected.devEui);
    }
  }, [data, state, setDevice]);

  const filterData = useMemo(
    () =>
      data.filter((item) =>
        item.name.toLocaleLowerCase().includes(search.toLocaleLowerCase()),
      ),
    [data, search],
  );

  const tabItems = useMemo(
    () =>
      device?.devEui
        ? [
            {
              key: "measurements",
              label: t("reports.tabMeasurements"),
              children: <TableReport t={t} device={device} />,
            },
          ]
        : [],
    [device, t],
  );

  const handleSelectDevice = (selected) => {
    setDevice(selected);
    setActiveKey(selected.devEui);
  };

  return (
    <div className="layout-content">
      <Row gutter={[20, 16]}>
        {/* Device list sidebar */}
        <Col xs={24} md={6} lg={5}>
          <Card
            bodyStyle={{ padding: "14px 12px" }}
            style={{
              borderRadius: 10,
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "none",
            }}
          >
            <Title
              level={5}
              style={{ margin: "0 0 12px", fontSize: 13, letterSpacing: 0.2 }}
            >
              {t("reports.measurement")}
            </Title>

            <SearchBar t={t} setSearch={setSearch} />

            <div
              style={{
                marginTop: 10,
                maxHeight: "calc(100vh - 260px)",
                overflowY: "auto",
              }}
            >
              {filterData.length > 0 ? (
                filterData.map((item) => (
                  <ItemCol
                    key={item.devEui}
                    t={t}
                    item={item}
                    isActiveHandlerItem={handleSelectDevice}
                    isActive={item.devEui === activeKey}
                  />
                ))
              ) : (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  style={{ marginTop: 24 }}
                  description={false}
                />
              )}
            </div>
          </Card>
        </Col>

        {/* Report content */}
        <Col xs={24} md={18} lg={19}>
          <Card
            bodyStyle={{ padding: "16px 20px" }}
            style={{
              borderRadius: 10,
              border: "1px solid rgba(0,0,0,0.08)",
              boxShadow: "none",
            }}
          >
            {device?.devEui ? (
              <Tabs items={tabItems} size="small" />
            ) : (
              <Empty
                style={{ padding: "60px 0" }}
                description={t("reports.tabMeasurements")}
              />
            )}
          </Card>
        </Col>
      </Row>
    </div>
  );
}
